import { useState, useCallback } from 'react';
import apiClient from '@/lib/apiClient';
import type { CheckRecord } from '@/types';

/**
 * useCheckRecords — 打卡记录 Hook
 * TODO: Backend 实现打卡系统后对接
 */
export const useCheckRecords = () => {
  const [records, setRecords] = useState<CheckRecord[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchRecords = useCallback(async (_params: Record<string, unknown> = {}) => {
    setLoading(true);
    try {
      // TODO: const data = await apiClient.get('/users/me/check-records', { params });
      return [] as CheckRecord[];
    } finally {
      setLoading(false);
    }
  }, []);

  return { records, loading, fetchRecords, setRecords };
};

export default useCheckRecords;
